

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://ed436f5053144538958ad06a5005e99a@sentry.wixpress.com/6142", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/63f463de1bc2bc5f/packages/members-area-notifications-preferences/src/components/PreferencesOoi/Widget/index.tsx';
    import createController from '/home/builduser/work/63f463de1bc2bc5f/packages/members-area-notifications-preferences/src/components/PreferencesOoi/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'PreferencesOoi';
    var projectName = 'members-area-notifications-preferences';
    var sentryConfig = {
      DSN: 'https://ed436f5053144538958ad06a5005e99a@sentry.wixpress.com/6142',
      id: 'undefined',
      projectName: 'members-area-notifications--0j',
      teamName: 'ping',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/63f463de1bc2bc5f/packages/members-area-notifications-preferences/src/components/PreferencesOoi/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"scopes":["viewer-apps-14f25dc5-6af3-5420-9568-f9c5ed98c9b1"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/work/63f463de1bc2bc5f/packages/members-area-notifications-preferences/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"app.settings.tabs.design.title-font.title":"Title text","app.widget.marketing-emails.subscription.subscribe":"Subscribe Now","app.widget.PROMOTIONAL.title":"Marketing emails","app.settings.tabs.design.background-section.title":"Backgrounds and borders","app.settings.tabs.design.border-color.title":"Border opacity and color","app.settings.tabs.design.button-text-color.title":"Button text color","app.settings.tabs.design":"Design","app.widget.TRANSACTIONAL.title":"Business transactional emails ","app.widget.marketing-emails.subscription-toast.error":"Email preferences weren't saved due to a technical issue on our end. Try again.","app.widget.marketing-emails.subscription-toast.success.subscribed":"You're subscribed to all marketing emails.","app.settings.tabs.design.button-section.title":"Button style","app.settings.tabs.design.border-width.title":"Border width","app.widget.marketing-emails.subscription-toast.success.unsubscribed":"You're unsubscribed from all marketing emails. You'll still get important emails about your account.","app.widget.marketing-emails.subscription.title.subscribed":"You are subscribed to marketing emails","app.settings.tabs.design.background-color.title":"Background opacity and color","app.settings.tabs.design.primary-font.title":"Body text","app.settings.tabs.design.text-color.title":"Text color","app.settings.tabs.design.button-opacity-and-color.title":"Button opacity and color","app.settings.label":"Settings","app.widget.title":"Email notification settings","app.widget.subtitle":"Choose what you want to get notified about.","app.widget.marketing-emails.subscription.title.unsubscribed":"You aren't subscribed to marketing emails","app.widget.marketing-emails.subscription.unsubscribe":"Unsubscribe"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "14f25dc5-6af3-5420-9568-f9c5ed98c9b1";
    var componentId = "14f25dd2-f9b0-edc2-f38e-eded5da094aa";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/63f463de1bc2bc5f/packages/members-area-notifications-preferences/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
      Sentry: window.Sentry && {
        forceLoad: () => window.Sentry.forceLoad(),
        onLoad: (fn) => window.Sentry.onLoad(() => fn(window.Sentry))
      }
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
